/** Until the viewer's blocked list is known, resolved rows are held back as loading so blocked creators never flash. */
export default function holdResolvedRows(rows) {
    return rows.map((row) => (row.status === "success" ? { status: "loading", block: row.block } : row));
}
